import { render, staticRenderFns } from "./honour.vue?vue&type=template&id=b6fce8e8&scoped=true&"
import script from "./honour.vue?vue&type=script&lang=js&"
export * from "./honour.vue?vue&type=script&lang=js&"
import style0 from "./honour.vue?vue&type=style&index=0&id=b6fce8e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fce8e8",
  null
  
)

export default component.exports